module.exports = "/_next/static/images/landing1-desktop-9dd35fe282bcfb7b76f531f4a272d149.png";